import { render } from "./color-select.vue?vue&type=template&id=e1e6184e"
import script from "./color-select.vue?vue&type=script&lang=js"
export * from "./color-select.vue?vue&type=script&lang=js"

import "./color-select.vue?vue&type=style&index=0&id=e1e6184e&lang=css"
script.render = render

export default script